import { useIdentityStore } from '@/store/IdentityStore';
import { useModalStore } from '@/store/ModalStore';
import { createRouter, createWebHashHistory } from 'vue-router';
import ApiService from '@/services/ApiService';
import RotatorView from '@/views/RotatorView.vue';

const routes = [
  {
    path: '/',
    name: 'pipepro',
    component: RotatorView
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_BASE),
  routes
});

router.beforeEach(async (to, from) => {
  // dynamic page title
  document.title = to.meta?.title ?? 'Nelson PipePro';
  if (process.env.NODE_ENV !== 'production') {
    console.log('To Path: ' + to.path);
    console.log('From Path: ' + from.path);
  }
  const identityStore = useIdentityStore();
  // dynamic page title
  document.title = to.meta?.title ?? 'Nelson PipePro';

  if (to.path !== '/callback') {
    // check to see if discovery document is stored
    if (!identityStore.discovery) {
      await identityStore.verifyDiscoveryDocument();
    }
    var token = identityStore.access_token();
    if (!token) {
      identityStore.ssoAuthenticate();
    }
    else {
      var bTokenActive = await identityStore.isTokenValid();
      if (!bTokenActive) {
        var refreshToken = identityStore.refresh_token();
        if (refreshToken) {
          await identityStore.ssoRefreshToken(refreshToken);
          token = identityStore.access_token();
          if (!token) {
            identityStore.ssoAuthenticate();
          }
        }
      }
      if (!ApiService.token) { ApiService.setAuthHeader(identityStore.access_token()); }
      var user = JSON.parse(localStorage.getItem('rotator_user'));
      const modalStore = useModalStore();
      if (!user) {
        identityStore.getTokenUser().then(() => {
          if (identityStore.User.properties.Rotator_HasAgreed === null) {
            modalStore.showModal('tos');
          }
        });
      }
      else {
        identityStore.User = user;
        if (identityStore.User.properties.Rotator_HasAgreed === null) {
          modalStore.showModal('tos');
        }
      }
    }
  }
});
router.onError(err => {
  print('<!-- router error: ' + err.message + ' -->');
});

export default router;